import { Card, List } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import { useLanguage } from "../../../../context/LanguageContext";
import dashboardContent from "../../../../utils/dashboardContent";

export default function TipsCard() {
  const { language } = useLanguage();
  const tipsData = dashboardContent[language].home.tips;

  return (
    <div className="w-full max-w-2xl">
      <Card
        title={tipsData.title}
        className="overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300"
        headStyle={{
          borderBottom: "none",
          fontSize: "1.5rem",
          fontWeight: "600",
          background: "linear-gradient(to right, #F4693B, #FAB97B)",
          color: "white",
          padding: "1rem",
        }}
        bodyStyle={{
          padding: "1.5rem",
        }}
      >
        <List
          dataSource={tipsData.list}
          renderItem={(tip) => (
            <List.Item className="flex items-start gap-3 px-0 hover:bg-gray-50 rounded-lg transition-colors duration-200">
              <div className="flex items-start gap-3 py-2">
                <CheckCircleOutlined className="text-emerald-500 text-lg mt-0.5" />
                <span className="text-gray-600">{tip}</span>
              </div>
            </List.Item>
          )}
        />
      </Card>
    </div>
  );
}
